import { useEffect } from 'react';
import type { UserContext } from '@/types/user-context';
import { useStore } from '@/store/store';
import { mergeUniqueArrays } from '@/utils/merge-unique-arrays/merge-unique-arrays';

export const useInitUserContext = (userContextResponse: UserContext | null) => {
    useEffect(() => {
        if (userContextResponse) {
            const { userContext } = useStore.getState();
            const { accountSettings } = userContextResponse;

            if (userContextResponse?.favouriteGames) {
                userContext.setFavoriteGames((current) =>
                    mergeUniqueArrays(current, userContextResponse.favouriteGames || [])
                );
            }
            if (accountSettings.accountID) {
                userContext.accountSettings.setAccountID(accountSettings.accountID);
            }
            if (accountSettings.username) {
                userContext.accountSettings.setUserName(accountSettings.username);
            }
            if (accountSettings.emailAddress) {
                userContext.accountSettings.setEmailAddress(accountSettings.emailAddress);
            }
        }
    }, [userContextResponse]);
};
